var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ScrollTop',[_c('a',{staticClass:"btn btn-light btn-toTop"},[_c('i',{staticClass:"bi bi-caret-up",attrs:{"data-toggle":"tooltip","data-placement":"bottom","title":"Nach oben"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }